import { getAuthors } from '@/graphql/queries/media/article';
import lang from '@/lang/middleware/media';

export default async ({ $apolloQuery, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  await $apolloQuery(getAuthors).then(authors => {
    store.commit('blog/setAuthors', authors);
    const description = store.$i18n.t('blog.authors.description');
    const title = store.$i18n.t('blog.authors.title');
    store.commit('pageContent/setHead', { description, title });
  });
};
